import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import MyStores from './MyStores'
import AllStores from './AllStores'
import { Container, Tab, tabClasses, TabList, TabPanel, Tabs } from '@mui/joy'
import { useAddAnonymousUserMutation } from '../services/users'

function Main() {
  const [token, setToken] = useState(localStorage.getItem(`token`))
  const [activeTab, setActiveTab] = useState<string | number | null>(0)
  const [addAnonymousUser, { isSuccess: isAddAnonymousUserSuccess }] =
    useAddAnonymousUserMutation()

  // useEffect(() => {
  //   if (userId === null) {
  //     const randomUserId = uuidv4()
  //     addAnonymousUser({ userId: randomUserId })
  //
  //     if (isAddAnonymousUserSuccess) {
  //       localStorage.setItem('userId', randomUserId)
  //       setUserId(randomUserId)
  //     }
  //   }
  // }, [userId])

  return (
    <Container maxWidth="xs" sx={{ pt: 2, pb: 2 }}>
      <Tabs
        value={activeTab}
        onChange={(
          event: React.SyntheticEvent | null,
          newValue: string | number | null,
        ) => setActiveTab(newValue)}
        variant="outlined"
        sx={{
          borderRadius: '6px',
          boxShadow: 'md',
          backgroundColor: 'rgba(221, 231, 238, 0.25)',
        }}
      >
        <TabList
          sticky="top"
          disableUnderline
          tabFlex={1}
          sx={{
            zIndex: 3,
            [`& .${tabClasses.root}`]: {
              fontSize: 'md',
              fontFamily: '"Inter"',
              backgroundColor: 'rgb(221,231,238)',
              [`&[aria-selected="true"]`]: {
                bgcolor: 'rgb(246, 249, 251)',
                alpha: 0.25,
                fontWeight: 'lg',
              },
              [`&.${tabClasses.focusVisible}`]: {
                outlineOffset: '-4px',
              },
            },
          }}
        >
          <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
            Üzleteim
          </Tab>
          <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
            Összes üzlet
          </Tab>
        </TabList>
        <TabPanel value={0}>
          <MyStores />
        </TabPanel>
        <TabPanel value={1}>
          <AllStores />
        </TabPanel>
      </Tabs>
    </Container>
  )
}

export default Main
